import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import GroupsEmptyStateSvg from '@web/assets/svg/Misc/empty-groups-state.svg';

const SVG_DISPLACEMENT = 56;

const GroupsEmptyState = () => (
  <Column mTop={60} alignItems="center">
    <Column mTop={20} mLeft={SVG_DISPLACEMENT} mBottom={20}>
      <GroupsEmptyStateSvg />
    </Column>
    <Text14 themeColor={ThemeColorType.gray} semiBold>
      {gettext('Looks like you have no groups yet.')}
    </Text14>
    <Text14 themeColor={ThemeColorType.gray} semiBold>
      {gettext('Add groups to be able to categorize your employees.')}
    </Text14>
  </Column>
);

export default GroupsEmptyState;
